import moment from "moment";
import { reportG9 } from "./../services/reportG9.service";
import { Loading } from "element-ui"

const month_th = [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]

const state = {
  showTable: false,
  bgTable: "",
  showDataNotFound: false,
  month_th: [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
  data_table: [],
  note: "",
  title: ""
};
const actions = {
  async report_data({ commit }, formdata) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    state.data_table = []
    let result = await reportG9.getReportData(formdata);
    if (result.status === 200) {
        if(result.data.length==0){
            state.showTable = false
            state.showDataNotFound = true
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            state.showDataNotFound = false
            state.showTable = true
            let data = result.data
            let data_table = []
            let providerlist = formdata.list;
            let technology_list= formdata.type_data.checkList;
            let provider_name = formdata.type_providers == 'group' ? providerlist[0].group_name_th : providerlist[0].brand_name
            technology_list = technology_sort(technology_list)
            formdata.technology_list = technology_list
            state.showTable = true
            let temp = technology_list[0]
            if(technology_list.length == 2){
              temp += ' และ ' +  technology_list[1]
            } else if(technology_list.length > 2){
              for(let i = 1; i < (technology_list.length-1); i++){
                temp += (', ' + technology_list[i])
              }
              temp += (' และ ' + technology_list[technology_list.length - 1])
            }
            state.title = temp +  ' ของผู้ให้บริการ ' + provider_name
            switch (formdata.type_report){
              case 'month':
                state.note = "ผู้ให้บริการ " + provider_name + " เดือน" + month_th[moment(formdata.type_data.month).month()] +
                " ปี " + moment(formdata.type_data.month).add(543,'y').year();
                break;
              case 'between_month':
                state.note = "ผู้ให้บริการ " + provider_name + " ระหว่างเดือน" + month_th[moment(formdata.type_data.monthfrom).month()] +
                " ปี " + moment(formdata.type_data.monthfrom).add(543,'y').year() +
                " ถึงเดือน" + month_th[moment(formdata.type_data.monthto).month()] +
                " ปี " + moment(formdata.type_data.monthto).add(543, 'y').year();
                break;
              case 'year':
                state.note = "ผู้ให้บริการ " + provider_name + " ปี " + moment(formdata.type_data.year).add(543,'y').year();
                break;
              case 'between_year':
                state.note = "ผู้ให้บริการ " + provider_name + " ปี " + moment(formdata.type_data.yearfrom).add(543,'y').year() +
                " ถึงปี " + moment(formdata.type_data.yearto).add(543, 'y').year();
                break;
              case 'quarter':
                state.note = "ผู้ให้บริการ " + provider_name + " ในไตรมาสที่ " + formdata.type_data.quarter + " ปี " + moment(formdata.type_data.quarter_year).add(543,'y').year();
                break;
              case 'between_quarter':
                state.note = "ผู้ให้บริการ " + provider_name + " ในไตรมาสที่ " + formdata.type_data.quarterfrom + " ปี " + moment(formdata.type_data.quarter_year_from).add(543,'y').year() +
                " ถึงไตรมาสที่ " + formdata.type_data.quarterto + " ปี " + moment(formdata.type_data.quarter_year).add(543, 'y').year();
                break;
            }
            let obj = {
              formdata: formdata,
              data: data
            }
            commit('SET_TABLE', obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
        }
    } else {
      console.log('err')
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  }
};

const mutations = {
  SET_TABLE(state, obj) {
    let data = obj.data
    let technology_list = obj.formdata.technology_list
    for(let i = 0; i < technology_list.length; i++){
      let technology_data = data.filter(current_technology => current_technology.promotion_technology == technology_list[i])
      let group_speed = []
      let speed = []
      let promotion_name = []
      for(let j = 0; j < technology_data.length; j++){
          promotion_name.push(technology_data[j].promotion_name_th)
          speed.push(technology_data[j].speed)
          group_speed.push({
            promotion_name: technology_data[j].promotion_name_th,
            speed: (technology_data[j].download_speed != null ? technology_data[j].download_speed : '-') + '/' + (technology_data[j].upload_speed != null ? technology_data[j].upload_speed : '-') + ' Mbps',
            sum_price: technology_data[j].promotion_price > 0 ? technology_data[j].promotion_price : 0,
            amount: technology_data[j].promotion_price > 0 ? 1 : 0
          })
      }
      if(group_speed.length == 0){
        state.data_table.push({
          rowspan: 1,
          type_technology: technology_list[i],
          promotion_name_th: '-',
          speed: '-',
          price_avg: '-'
        })
      } else {
        for(let row = 0; row < group_speed.length; row++){
          if(row == 0){
            state.data_table.push({
              rowspan: group_speed.length,
              type_technology: technology_list[i],
              promotion_name_th: group_speed[row].promotion_name,
              speed: group_speed[row].speed,
              price_avg: formatNumber(group_speed[row].sum_price)
            })
          } else {
            state.data_table.push({
              rowspan: 0,
              type_technology: technology_list[i],
              promotion_name_th: group_speed[row].promotion_name,
              speed: group_speed[row].speed,
              price_avg: formatNumber(group_speed[row].sum_price)
            })
          }
        }
      }
    }
  }
}

function formatNumber(num) {
  if (isNaN(num) || num == 0) {
    return '-'
  } else if (num >= 10) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else if( num < 1 ) {
    return num;
  }
}

function technology_sort(data) {
  let technology_sort = []
  if(data.includes('ADSL')) {
    technology_sort.push('ADSL')
  }
  if(data.includes('VDSL')) {
    technology_sort.push('VDSL')
  }
  if(data.includes('FTTx')) {
    technology_sort.push('FTTx')
  }
  if(data.includes('WiFi')) {
    technology_sort.push('WiFi')
  }
  if(data.includes('VAS')) {
    technology_sort.push('VAS')
  }
  return technology_sort
}

export const Report_G9 = {
  namespaced: true,
  state,
  actions,
  mutations
};
